import React from 'react';
import PropTypes from 'prop-types';
// constants
import ROLES from '../../constants/Roles';
// visual elements
import DetailView from '../Common/DetailView';

import AutoComplete from '../Common/AutoComplete';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import Dialog from 'material-ui/Dialog';
import LoadingDialog from '../Common/LoadingDialog';
import MenuItem from 'material-ui/MenuItem';
import UserComplianceCard from './UserCompliancesCard';

import FlatButton from 'material-ui/FlatButton';

import Pills from '../Common/Pill';
// -- icons:
import PersonAddIcon from 'material-ui/svg-icons/social/person-add';
import GroupAddIcon from 'material-ui/svg-icons/social/group-add';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import IconPerson from 'material-ui/svg-icons/social/person';
import IconProfile from 'material-ui/svg-icons/action/perm-identity';
import IconPeople from 'material-ui/svg-icons/social/people';
import IconPeopleOutline from 'material-ui/svg-icons/social/people-outline';
// business logic
import buildContextMenu from '../Common/BuildContextMenu';

import UserStore from '../../stores/UserStore';
import ManagerStore from '../../stores/ManagerStore';
import UserActions from '../../actions/UserActionCreator';
import UserGroupStore from '../../stores/UserGroupStore';
import UserGroupActions from '../../actions/UserGroupActionCreator';
import DepartmentStore from '../../stores/DepartmentStore';
import DepartmentActions from '../../actions/DepartmentActionCreator';

import { statusColours } from '../../constants/ColourConstants';

import { formatName } from '../../utils/StringUtils';
import ErrorSnackbar from '../Common/ErrorSnackbar';
import { withId } from '../Common/Decorators';


let timeout;

const iconProps = {
    color: statusColours.default,
};

const getMenuItems = (id, openDialog) => [
    {
        link: `/dashboard/user/${id}`,
        icon: <IconProfile />,
        label: 'User profile',
    },
    {
        type: 'divider'
    },
    {
        icon: <GroupAddIcon />,
        label: 'Add department',
        action: () => openDialog('department'),
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        icon: <GroupAddIcon />,
        label: 'Add group',
        action: () => openDialog('group'),
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        icon: <PersonAddIcon />,
        label: 'Add manager',
        action: () => openDialog('manager'),
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        type: 'divider'
    },
    {
        link: `/dashboard/user/${id}/edit`,
        icon: <EditIcon />,
        label: 'Edit',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
];


const UserSettings = React.createClass({

    getInitialState: function() {
        return {
            details: {
                id: '',
                fullName: '',
                title: '',
                firstName: '',
                lastName: '',
                initials: '',
                dateOfBirth: '',
                jobRole: '',
                username: '',
                email: '',
                visits: '',
                lastLogin : '',
                departments: [],
                userGroups: [],
                roles: [],
                managers: [],
            },
            actions: [],
            roles: UserStore.getRoles(),
            groups: [],
            departments: [],
            managers: null,
            dialog: {
                open: false,
                value: null,
            },
            links: {
                back: `/dashboard/user/${this.props.id}`,
            }
        };
    },

    componentWillMount() {
        this.setState({ actions: buildContextMenu(getMenuItems(this.props.id, this._openDialog), this.context.auth) } );

    },

    componentDidMount: function(){
        this.listeners = [
            UserStore.addListener(this._onChange),
            UserGroupStore.addListener(this._onLoadGroups),
            DepartmentStore.addListener(this._onLoadDepartments),
            ManagerStore.addListener(this.onManagersChange),
        ];
        UserActions.getById(this.props.id);
        UserActions.getManagers({limit: 0});
        UserGroupActions.getAll();
    },

    componentWillUnmount: function() {
        this.listeners.forEach(listener => listener.remove());
    },

    render: function() {
        const userId = Number(this.props.id);

        let groupPills = Pills.create(this.state.details.userGroups, this.state.groups, this._removeGroup);
        let departmentPills  = Pills.create(this.state.details.departments, this.state.departments, this._removeDepartment);
        let managerPills = Pills.create(this.state.details.managers, this.state.managers, this._removeManager);

        let dialogActions = [
            <FlatButton label="Cancel" onTouchTap={this._closeDialog} />,
            <FlatButton label="Submit" onTouchTap={this._dialogSave} disabled={this.state.dialog.value === null} />,
        ];
        let activeDialog = '';
        if (this.state.dialog.open === 'manager') {
            let dialogProps = {title: "Add manager", open: true};
            if (this.state.managers.length === 0) {
                dialogProps.buttonAction = this._closeDialog;
                activeDialog = <LoadingDialog {...dialogProps}/>;
            } else {
                dialogProps.actions = dialogActions;
                dialogProps.onRequestClose = this._closeDialog;
                activeDialog = (
                    <Dialog {...dialogProps} >
                        <AutoComplete
                            floatingLabelText="Manager Name"
                            maxSearchResults={5}
                            dataSource={this.state.managers}
                        />
                    </Dialog>
                );
            }
        } else if (this.state.dialog.open === 'department') {
            let dialogProps = {
                title: "Add department",
                open: true,
                actions: dialogActions,
                onRequestClose: this._handleClose
            };
            activeDialog = (
                <Dialog {...dialogProps} >
                    <AutoComplete
                        floatingLabelText="Department"
                        maxSearchResults={5}
                        dataSource={this.state.departments}
                        onUpdateInput={this._onDepartmentAutocomplete}
                    />
                </Dialog>
            );
        } else if (this.state.dialog.open === 'group') {
            let dialogProps = {title: "Add group", open: true};
            if (this.state.groups.length === 0) {
                dialogProps.buttonAction = this._closeDialog;
                activeDialog = <LoadingDialog {...dialogProps}/>;
            } else {
                dialogProps.actions = dialogActions;
                dialogProps.onRequestClose = this._handleClose;
                activeDialog = (
                    <Dialog {...dialogProps} >
                        <AutoComplete
                            floatingLabelText="Group"
                            maxSearchResults={5}
                            dataSource={this.state.groups}
                        />
                    </Dialog>
                );
            }

        }

        return (
            <DetailView
                title={formatName(this.state.details)}
                backButton={true}
                backTo={this.state.links.back}
                actions={this.state.actions}
            >
                <div className="cent-cards">

{/*                    <DepartmentSegmentAdmin
                        departments={this.state.details.departments}
                        addAction={this._openDialog.bind(this, 'department')}
                        deleteAction={(departmentId) =>  UserActions.removeDepartment(this.props.id, departmentId)}
                    />*/}

                    <Card className="cent-card">
                        <CardHeader
                            title='Departments'
                            subtitle='manage user membership'
                            avatar={<IconPeopleOutline {...iconProps}/>}
                        />
                        <CardText className="cent-card-text">
                            <ul className="cent-pills">{departmentPills}</ul>
                        </CardText>
                    </Card>

                    <Card className="cent-card">
                        <CardHeader
                            title='Groups'
                            subtitle='manage user membership'
                            avatar={<IconPeople {...iconProps}/>}
                        />
                        <CardText className="cent-card-text">
                            <ul className="cent-pills">{groupPills}</ul>
                        </CardText>
                    </Card>
                    <Card className="cent-card">
                        <CardHeader
                            title='Managers'
                            subtitle='manage user managers'
                            avatar={<IconPerson {...iconProps}/>}
                        />
                        <CardText className="cent-card-text">
                            <ul className="cent-pills">{managerPills}</ul>
                        </CardText>
                    </Card>
                    <UserComplianceCard cardType="12" userId={userId} />
                </div>
                <ErrorSnackbar />
            {activeDialog}
            </DetailView>
        );
    },

    _onChange: function() {
        const details = UserStore.getById(this.props.id);
        if (details !== undefined) {
            if (!!details.departments) {
                details.departments.forEach((department) => (!!department.id) && DepartmentActions.getById(department.id));
            }
            this.setState({details});
        }
    },

    onManagersChange() {
        if (ManagerStore.isFetching()) {
            this.setState({managers: null});
        } else {
            const managerList = ManagerStore.getAll();
            if (managerList !== undefined) {
                const managers = managerList.map((manager) => {
                    const click = this._onDialogSelect.bind(this, manager);
                    const name = formatName(manager);
                    return {
                        id: manager.id,
                        name: name,
                        text: name,
                        value: <MenuItem key={manager.id} value={manager.id} primaryText={name} onTouchTap={click} />
                    };
                }, this);
                this.setState({managers});
            }
        }
    },

    _onLoadGroups: function() {
        const groupList = UserGroupStore.getAll();
        if (groupList !== undefined) {
            const groups = groupList.map((group) => {
                const click = this._onDialogSelect.bind(this, group);
                return {
                    id: group.id,
                    name: group.name,
                    text: group.name,
                    value: <MenuItem key={group.id} value={group.id} primaryText={group.name} onTouchTap={click} />
                };
            }, this);
            this.setState({groups});
        }
    },

    _onDepartmentAutocomplete: function(input) {
        clearTimeout(timeout);
        if (input !== undefined && input.length >= 2) {
            timeout = setTimeout(() => DepartmentActions.search(input, {limit: 10, strict: true, userId: this.props.id}), 300);
        }
    },

    _onLoadDepartments: function() {
        const departmentList = DepartmentStore.getAll();
        if (departmentList !== undefined) {
            const departments = departmentList.map((department) => {
                const click = this._onDialogSelect.bind(this, department);
                return {
                    id: department.id,
                    name: department.name,
                    text: department.name,
                    value: <MenuItem key={department.id} value={department.id} primaryText={department.name} onTouchTap={click} />
                };
            }, this);
            this.setState({departments});
        }
    },

    // dialog handlers:
    _closeDialog: function() {
        this.setState({dialog: {...this.state.dialog, open: false}});
    },
    _openDialog: function(open) {
        this.setState({dialog: { open, value: null}});
    },

    _dialogSave: function() {
        let close = true;
        switch (this.state.dialog.open) {
            case 'manager':
                close = this._addManager(this.state.dialog.value);
                break;
            case 'department':
                close = this._addDepartment(this.state.dialog.value);
                break;
            case 'group':
                close = this._addGroup(this.state.dialog.value);
                break;
            default:
                console.error('Error: unhandled dialog');
                close = false;
        }

        if (close) this._closeDialog();

    },

    _onDialogSelect(value) {
        this.setState({dialog: {
            ...this.state.dialog,
            value
        }});
    },

    // individual dialog handling:
    _addManager: function(manager) {
        let ok = true;
        let state = {...this.state};
        if (0 <= this.state.details.managers.findIndex(function(m) { return m !== undefined && m.id == manager.id; })) {
            ok = false;
            state.dialog.value = null;
        } else {
            UserActions.addManager(this.props.id, {managerId: manager.id});
            manager.loading = true;
            state.details.managers.push(manager);
        }
        this.setState(state);
        return ok;
    },

    _removeManager: function(managerId) {
        let state = {...this.state};
        let i = this.state.details.managers.findIndex(function(m) { return m !== undefined && m.id == managerId; });
        if (i >= 0) {
            UserActions.removeManager(this.props.id, managerId);
            state.details.managers[i].loading = true;
            this.setState(state);
        }
    },

    _addDepartment: function(department) {
        let ok = true;
        if (0 <= this.state.details.departments.findIndex(m => !!m && m.id == department.id )) {
            ok = false;
            this._onDialogSelect(null);
        } else {
            UserActions.addDepartment(this.props.id, {departmentId: department.id});
            const details = {
                ...this.state.details,
                departments: [
                    ...this.state.details.departments,
                    {id: department.id, loading: true}
                ]
            };
            this.setState({details});
        }
        return ok;
    },

    _removeDepartment: function(departmentId) {
        const index = this.state.details.departments.findIndex(d => !!d && d.id === departmentId);
        if (-1 < index) {
            UserActions.removeDepartment(this.props.id, departmentId);
            const details = {
                ...this.state.details,
                departments: this.state.details.departments.map((d, i) => (i !== index) ? d : { ...d, loading: true })
            };
            this.setState({details});
        }
    },

    _addGroup: function(group) {
        let ok = true;
        let state = this.state;
        if (0 <= this.state.details.userGroups.findIndex(function(m) { return m !== undefined && m.id == group.id; })) {
            ok = false;
            state.dialog.value = null;
        } else {
            UserActions.addGroup(this.props.id, {userGroupId: group.id});
            state.details.userGroups.push({id: group.id, loading: true});
        }
        this.setState(state);
        return ok;
    },

    _removeGroup: function(groupId) {
        let state = this.state;
        let i = this.state.details.userGroups.findIndex(function(m) { return m !== undefined && m.id == groupId; });
        if (i >= 0) {
            UserActions.removeGroup(this.props.id, groupId);
            state.details.userGroups[i].loading = true;
            this.setState(state);
        }
    },

});

UserSettings.contextTypes = {
    auth: PropTypes.object
};

export default withId(UserSettings);
